import React from 'react';
import { OptionComponent } from 'components/shared/forms/selectWithExtendedOptions/types';
import { IMaster } from 'components/user/socialTrading/social.interfaces';
import { OptionContent } from './optionContent/optionContent';

export const getOptions = (optionsData: Array<IMaster>): OptionComponent[] => {
  return optionsData.map((option) => {
    return {
      optionComponent: <OptionContent key={option.login} option={option} />,
      optionValue: option.masterAccountId,
    };
  });
};
